import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import GUI from 'lil-gui'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'
import gsap from 'gsap'

// lil-gui
const gui = new GUI()


// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

// Textures
const textureLoader = new THREE.TextureLoader()
const material = new THREE.MeshMatcapMaterial()
const matcapTexture = textureLoader.load('/textures/matcaps/9.png')
matcapTexture.colorSpace = THREE.SRGBColorSpace

const christmasTree = new THREE.Group()
const giftBoxes = new THREE.Group()

// Ground

const planeGeometry = new THREE.PlaneGeometry(2.5, 2)
const ground = new THREE.Mesh(planeGeometry, material)
ground.rotation.x = -1.5

scene.add(ground)


// Gift Boxes

const giftBox1 = new THREE.Mesh(
    new THREE.BoxGeometry(),
    new THREE.MeshBasicMaterial({ color: "indigo" })
)

giftBox1.scale.set(0.3, 0.3, 0.3)
giftBox1.position.x -= 0.3

const giftBox2 = new THREE.Mesh(
    new THREE.BoxGeometry(),
    new THREE.MeshBasicMaterial({ color: "cyan" })
)

giftBox2.scale.set(0.3, 0.3, 0.3)
giftBox2.position.x -= 0.85


const giftBox3 = new THREE.Mesh(
    new THREE.BoxGeometry(),
    new THREE.MeshBasicMaterial({ color: "blue" })
)
giftBox3.position.x -= 0.55
giftBox3.position.z += 0.35
giftBox3.scale.set(0.3, 0.3, 0.3)

// Gift knots
const knotMaterial = new THREE.MeshBasicMaterial({ color: "orange" })
const knotWrap = new THREE.TorusKnotGeometry(0.3, 0.07, 16, 4, 6, 5)
const knot1 = new THREE.Mesh(knotWrap, knotMaterial)
knot1.position.x -= 0.85
knot1.rotation.x -= 1
knot1.scale.set(0.2, 0.2, 0.2)
knot1.position.y += 0.2
scene.add(knot1)

const knot2 = new THREE.Mesh(knotWrap, knotMaterial)
knot2.position.x -= 0.3
knot2.rotation.x -= 1
knot2.scale.set(0.2, 0.2, 0.2)
knot2.position.y += 0.2
scene.add(knot2)

const knot3 = new THREE.Mesh(knotWrap, knotMaterial)
knot3.position.x -= 0.55
knot3.rotation.x -= 1
knot3.position.z += 0.35
knot3.scale.set(0.2, 0.2, 0.2)
knot3.position.y += 0.2
scene.add(knot3)

giftBoxes.add(giftBox1, giftBox2, giftBox3);

scene.add(giftBoxes);


// Tree trunk
const trunkGeometry = new THREE.CylinderGeometry(0.1, 0.1, 1, 8);
const trunkMaterial = new THREE.MeshBasicMaterial({ color: "brown" })
const trunk = new THREE.Mesh(trunkGeometry, trunkMaterial)
trunk.position.y += 0.4
christmasTree.add(trunk)

// Tree top
const treeTopGeometry = new THREE.ConeGeometry(0.4, 1, 6);
const treeTopMaterial = new THREE.MeshBasicMaterial({ color: "green" })
const treeTop = new THREE.Mesh(treeTopGeometry, treeTopMaterial)
treeTop.position.y += 1
christmasTree.add(treeTop)

scene.add(christmasTree)
christmasTree.position.x -= 0.6
christmasTree.position.y += 0.1

// Snowman

const snowMan = new THREE.Group()

// Snowman Head
const snowManHeadGeometry = new THREE.SphereGeometry(0.2)
const snowManHead = new THREE.Mesh(snowManHeadGeometry, material)
snowManHead.position.y += 0.5

// Snowman Eyes
const eyeMaterial = new THREE.MeshBasicMaterial({ color: "blue" })
const eyeGeometry = new THREE.SphereGeometry(0.02)
const leftEye = new THREE.Mesh(eyeGeometry, eyeMaterial)

const noseGeometry = new THREE.ConeGeometry(0.05, 0.2, 9);
const noseMaterial = new THREE.MeshBasicMaterial({ color: "orange" })
const nose = new THREE.Mesh(noseGeometry, noseMaterial)
nose.rotation.x -= 4
nose.position.y += 0.45
nose.position.z += 0.24


leftEye.position.x -= 0.07
leftEye.position.y += 0.6
leftEye.position.z += 0.18

const rightEye = new THREE.Mesh(eyeGeometry, eyeMaterial)

rightEye.position.x += 0.07
rightEye.position.y += 0.6
rightEye.position.z += 0.18


// Snowman hat
const hatGeometry = new THREE.ConeGeometry(0.4, 0.2, 9);
const hatMaterial = new THREE.MeshBasicMaterial({ color: "red" })
const hat = new THREE.Mesh(hatGeometry, hatMaterial)
hat.position.y += 0.75

// Scarf
const scarfGeometry = new THREE.TorusKnotGeometry(0.2, 0.07, 16, 4, 3, 2)
const scarfMaterial = new THREE.MeshBasicMaterial({ color: 'maroon' })
const scarf = new THREE.Mesh(scarfGeometry, scarfMaterial)

scarf.rotation.x += 2
scarf.position.y += 0.3

snowMan.add(snowManHead)
snowMan.add(leftEye)
snowMan.add(rightEye)
snowMan.add(nose)
snowMan.add(hat)
snowMan.add(scarf)


// Snowman Belly
const snowManBellyGeometry = new THREE.SphereGeometry(0.4)
const snowManBelly = new THREE.Mesh(snowManBellyGeometry, material)
snowMan.add(snowManBelly)

snowMan.position.x += 0.4
snowMan.position.y += 0.1
scene.add(snowMan)


/**
 * Fonts
 */
const fontLoader = new FontLoader()
fontLoader.load(
    '/fonts/poppins.json',
    (font) => {
        // Geometry
        const textGeometry = new TextGeometry(
            'Merry Christmas',
            {
                font: font,
                size: 0.2,
                depth: 0.05,
                curveSegments: 5,
                bevelEnabled: true,
                bevelThickness: 0.01,
                bevelSize: 0.01,
                bevelOffset: 0,
                bevelSegments: 2
            }
        )

        textGeometry.center()

        const textMaterial = new THREE.MeshMatcapMaterial()
        textMaterial.matcap = matcapTexture

        const text = new THREE.Mesh(textGeometry, textMaterial)
        text.position.y += 0.05
        text.position.z += 0.8
        scene.add(text)

        const snowGeometry = new THREE.IcosahedronGeometry(0.07, 0)

        for (let i = 0; i < 300; i++) {
            const snow = new THREE.Mesh(snowGeometry, material)

            snow.position.x = (Math.random() - 0.5) * 10
            snow.position.y = (Math.random() - 0.5) * 10
            snow.position.z = (Math.random() - 0.5) * 15


            scene.add(snow)
        }
    }
)


/**
 * Object
 */



/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height)
camera.position.x = 1
camera.position.y = 1
camera.position.z = 2
scene.add(camera)

// Controls 
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/* 
    Animate
*/

const clock = new THREE.Clock()

const animate = () => {
    const elapsedTime = clock.getElapsedTime()

    // Update controls
    controls.update()

    // Render 
    renderer.render(scene, camera)

    // Call it again and again
    window.requestAnimationFrame(animate)
}

animate()


// GSAP animations


const debugObject = {}


// WiggleHat
debugObject.wiggleHat = () => {
    gsap.to(hat.rotation, {
        duration: 0.2,
        z: hat.rotation.z + 0.2,
        yoyo: true,
        repeat: 5,
        ease: "power1.inOut"
    })
}
gui.add(debugObject, 'wiggleHat')



// spin
debugObject.spin = () => {
    gsap.to(snowMan.rotation, { duration: 1, y: snowMan.rotation.y + Math.PI * 2 })
}
gui.add(debugObject, 'spin')


// jump
debugObject.jump = () => {
    gsap.to(snowMan.position,
        {
            duration: 0.5,
            y: snowMan.position.y + 0.4,
            onComplete: () => {
                // Move down
                gsap.to(snowMan.position, {
                    duration: 0.5,
                    y: snowMan.position.y - 0.4
                })
            }
        })
}
gui.add(debugObject, 'jump')


// snowman dance
debugObject.dance = () => {
    gsap.to(snowMan.position, {
        duration: 0.5, // lasts 0.5 sec
        y: snowMan.position.y + 0.2,
        yoyo: true,
        repeat: 5, // does it 5 times, so 2.5 seconds in total
        ease: "power1.inOut"
    })
    gsap.to(snowMan.rotation, {
        duration: 2,
        y: snowMan.rotation.y + Math.PI * 2,
        ease: "power1.inOut" // easing function to help smooth it at beginning and end
    })
}

gui.add(debugObject, 'dance')